import ReactPlayer from 'react-player'
import get from 'lodash/get'
import React from 'react'
import { Block } from '@xprog/prensa'

type VideoProps = {
  videoCode?: string
  thumbnail?: string
  alt?: string
}

const midiaMp4Href = 'https://cdn.ojc.com.br/videos/mp4/'

const VideoComponent: React.FC<VideoProps> = ({
  videoCode,
  thumbnail,
  alt
}) => {
  let light
  let maxHeightLg = 'calc(calc(calc(100vw + 4px) / 3) * 2)'
  if (thumbnail) {
    light = <img src={thumbnail} alt={alt} style={{ width: '100%' }} />
    maxHeightLg = 'calc(50vw + 30px)'
  }
  return (
    <Block
      css={{
        position: 'relative',
        paddingTop: '-56.25%',
        marginBottom: '16px',
        width: '100%',
        iframe: {
          marginBottom: '0px',
          minHeight: '500px'
        },
        '.react-player': {
          position: 'absolute',
          top: 0,
          left: 0
        }
      }}
    >
      <ReactPlayer
        controls={true}
        light={light}
        url={videoCode}
        height='100%'
        width='100%'
      />
    </Block>
  )
}

const VideoWrap: React.FC<any> = (props) => {
  const videoLink = get(props, 'link', false)
  const videoCode = get(props, 'slotTemplateCode', false)
  const videoLinkUrl = videoLink ? `${midiaMp4Href}${videoLink}` : videoCode.indexOf('/') > -1 ? videoCode : `${midiaMp4Href}${videoCode}`
  return (
    <VideoComponent
      alt={props.alt}
      videoCode={videoLinkUrl}
      thumbnail={props.thumbnail}
    />
  )
}

export { VideoComponent, VideoWrap }
